<template>
    <div>
      <v-card class="ma-2">
        <v-card-title test-tag="tag-261"><T>Фильтры</T></v-card-title>
        <v-card-text>
          <div style="width: 100%;" class="d-flex">
            <DateFilter :minusDaysForStartDate="7" ref="dateFilter" />
            <v-btn test-tag="tag-258" class="mx-2" fab dark color="success" @click="updateData">
              <v-icon dark>mdi-autorenew</v-icon>
            </v-btn>
          </div>
          <div>
              <TextField
              dense
              class="mx-2 shrink"
              v-model="searchQuery"
              prepend-inner-icon="mdi-magnify"
              label="Поиск"
              single-line
              hide-details
              style="height: 40px; width: 300px;"
              />
          </div>
        </v-card-text>
      </v-card>
  
      <v-card class="ma-2">
        <v-card-title test-tag="tag-262"><T>Удаленные заказы</T></v-card-title>
        <v-card-text>
          <v-data-table test-tag="tag-260"
            :headers="headers"
            :items="filteredTableData"
            :loading="tableLoad"
            :loading-text="$t('Данные загружаются...')"
            :no-data-text="$t('Данные не найдены')"
            hide-default-footer
          >
            <template v-slot:item.guest="{ item }">
              <div>
                {{ item.name }}<br>
                {{ item.phone_number }}
              </div>
            </template>
            <template v-slot:item.orderType="{ item }">
              <div>{{ item.orderType }}</div>
            </template>

            <template v-slot:item.view="{ item }">
              <v-icon small class="cursor-pointer" @click="showOrderDetails(item)">
                mdi-eye
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
  
      <v-dialog v-model="dialog" max-width="700">
        <v-card>
          <v-card-title test-tag="tag-263"><T>Содержимое заказа</T></v-card-title>
          <v-card-text>
            <div v-if="loading_order" class="d-flex flex-column align-center" style="height:100px">
              <v-progress-circular size="45" indeterminate color="primary" />
              <span>{{ $t('Загрузка содержимого заказа...') }}</span>
            </div>
            <div v-else>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>{{ $t('Название') }}</th>
                    <th>{{ $t('Количество') }}</th>
                    <th>{{ $t('Сумма') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in order_content.items" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.sum }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div class="mt-4">
                <div><strong>{{ $t('Итоговая сумма:') }}</strong> {{ order_content.order_total }}</div>
                <div><strong>{{ $t('Скидка:') }}</strong> {{ order_content.discount_sum }}</div>
                <div><strong>{{ $t('Наценка:') }}</strong> {{ order_content.markup_sum }}</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn test-tag="tag-259" text @click="closeDialog">{{ $t('Закрыть') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import DateFilter from '../../components/orders/DateFilter.vue';
  import TextField from '../../components/common/TextField.vue'
  export default {
    name: 'guestsReport',
  
    components: {
      DateFilter,
      TextField
    },
  
    data() {
      return {
        tableData: [],
        tableLoad: false,
        headers: [
          { text: this.$t('№ Заказа'), value: 'id', align: 'start' },
          { text: this.$t('Гость (ФИО + Телефон)'), value: 'guest', align: 'start' },
          { text: this.$t('Тип заказа'), value: 'orderType', align: 'center' },
          { text: this.$t('Сумма заказа'), value: 'rk_sum', align: 'center' },
          { text: this.$t('Дата'), value: 'date', align: 'center' },
          { text: this.$t('Принят'), value: 'accepted', align: 'center' },
          { text: this.$t('Удален'), value: 'deleted', align: 'center' },
          { text: this.$t('Длительность'), value: 'duration', align: 'center' },
          { text: this.$t('Удалил'), value: 'operatorInfo', align: 'center' },
          { text: this.$t('Заказ'), value: 'view', align: 'center' }
        ],
        dateBegin: null,
        dateEnd: null,
        dialog: false,
        panels: [],
        selectedOrder: null,
        loading_order: false,
        order_content: {},
        orderId: null,
        searchQuery: ''
      };
    },
  
    computed: {
      formattedTableData() {
        return this.tableData.map(item => {
          const createdDate = new Date(item.created_at);
          const deletedDate = new Date(item.deleted_at);
  
          const formatDate = date => {
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const year = date.getUTCFullYear();
            return `${day}.${month}.${year}`;
          };
  
          const formatTime = date => {
            const hours = String(date.getUTCHours()).padStart(2, '0');
            const minutes = String(date.getUTCMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
          };
  
          const getDuration = (startDate, endDate) => {
            const durationMs = endDate - startDate; // разница в миллисекундах
            const hours = Math.floor(durationMs / 3600000); // конвертируем в часы
            const minutes = Math.floor((durationMs % 3600000) / 60000); // оставшиеся минуты
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
          };
          const durationFormatted = getDuration(createdDate, deletedDate);
  
          let orderTypeText = '';
          if (item.order_type === 'DELIVERY') {
            orderTypeText = this.$t('Доставка');
          } else if (item.order_type === 'TAKEAWAY') {
            orderTypeText = this.$t('Самовывоз');
          } else if (item.order_type === 'INPLACE') {
            orderTypeText = this.$t('В зале');
          } else {
            orderTypeText = item.order_type;
          }
  
          const operatorInfo = item.operator ? item.operator : this.$t('удален на кассе');
  
          return {
            ...item,
            date: formatDate(createdDate),
            accepted: formatTime(createdDate),
            deleted: formatTime(deletedDate),
            duration: durationFormatted,
            orderType: orderTypeText,
            operatorInfo
          };
        });
      },
      filteredTableData() {
        const searchVal = this.searchQuery.toLowerCase();
        if (!searchVal) {
            return this.formattedTableData;
        }
        return this.formattedTableData.filter(item => {
        return (
            String(item.id).toLowerCase().includes(searchVal) ||
            (item.name && item.name.toLowerCase().includes(searchVal)) ||
            (item.phone_number && item.phone_number.toLowerCase().includes(searchVal)) ||
            (item.orderType && item.orderType.toLowerCase().includes(searchVal)) ||
            (item.operator && item.operator.toLowerCase().includes(searchVal)) ||
            (item.date && item.date.toLowerCase().includes(searchVal))
        );
        });
    }
    },
  
    async mounted() {
      this.resetTable();
    },
  
    methods: {
      async resetTable() {
        this.dateBegin = this.$refs.dateFilter.getDateBegin();
        this.dateEnd = this.$refs.dateFilter.getDateEnd();
        this.tableLoad = true;
        this.tableData = await this.$store.dispatch('getRemoteOrdersReportInfo', {
          date_begin: this.dateBegin,
          date_end: this.dateEnd
        });
        this.tableLoad = false;
      },
      updateData() {
        this.resetTable();
      },
  
      async showOrderDetails(order) {
        this.selectedOrder = order;
        this.dialog = true;
        this.orderId = order.id;
        await this.open_order_content();
      },
  
      async open_order_content() {
        this.loading_order = true;
        this.order_content = await this.$store.dispatch('getOrderContentByID', this.orderId);
        this.loading_order = false;
      },
  
      closeDialog() {
        this.dialog = false;
        this.order_content = {};
        this.panels = [];
      }
    }
  };
  </script>
  
  <style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  </style>